import type { Task, TaskResponseItem } from './task';

export const mapTask = ({
    ID,
    POSITION,
    RESULTS,
    STATUS,
    TOTAL,
    TYPE,
}: TaskResponseItem): Omit<Task, 'uuid' | 'created' | 'status'> => ({
    id: ID,
    type: TYPE,
    systemStatus: STATUS,
    results: RESULTS,
    position: POSITION,
    total: TOTAL,
});
